export default [
  {
    path: '',
    name: 'apps-url-list',
    component: () => import(/* webpackChunkName: "apps-url-list" */ '@/apps/url/pages/UrlListPage.vue'),
    meta: {
      layout: 'content',
    },
  },
]
